import { render, staticRenderFns } from "./subPageThr.vue?vue&type=template&id=5ac2f8c1&scoped=true"
import script from "./subPageThr.vue?vue&type=script&lang=js"
export * from "./subPageThr.vue?vue&type=script&lang=js"
import style0 from "./subPageThr.vue?vue&type=style&index=0&id=5ac2f8c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac2f8c1",
  null
  
)

export default component.exports